export default "__VITE_ASSET__2954e2c9__"